import abstract from './abstract'
import Video from './video'

import VideoSlider from '@/sections/video-slider'

export default class extends abstract {
  getComponent () {
    return VideoSlider
  }

  get videos () {
    return this.item.properties.videos.map(video => new Video(video))
  }
}



// WEBPACK FOOTER //
// ./src/models/sections/video-slider.js